<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'커뮤니티'"></sub-visual>
        <div class="tab-list--primary-wrap">
            <ul class="tab-list tab-list--primary">
                <li class="on"><router-link to="/community/notice" class="button">공지사항</router-link></li>
                <li><router-link to="/community/reference" class="button">자료실</router-link></li>
                <li><router-link to="/community/qna" class="button">QnA</router-link></li>
            </ul>
        </div>
        
        <section class="section">
            <v-container>
                <tit-primary
                sc="notice"
                tit="공지사항">
                </tit-primary>

                <div class="board-container">
                    <!-- 1. 게시판 리스트: 베이직 스킨 -->
                    <notification-list v-if="!$route.params._notification"></notification-list>
                    <notification-view v-else></notification-view>
                    <!-- 2. 게시판 작성: 베이직 스킨 -->
                    <!-- <board-basic-input></board-basic-input> -->
                    <!-- 3. 게시판 뷰: 베이직 스킨 -->
                    <!-- <board-basic-view></board-basic-view> -->
                </div>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import NotificationList from "@/components/client/center/notifications/notification-list.vue";
import NotificationView from "@/components/client/center/notifications/notification-view.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
		NotificationList,
		NotificationView,
        TitPrimary,
    },
};
</script>